import { render } from "./Resultados.vue?vue&type=template&id=73f648b0&ts=true"
import script from "./Resultados.vue?vue&type=script&lang=ts"
export * from "./Resultados.vue?vue&type=script&lang=ts"

import "./Resultados.vue?vue&type=style&index=0&id=73f648b0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__